'use client';

import React from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PhProvider } from 'posthog-js/react';
import { isEnvDev } from 'utils';
import { useAppCookieConsent } from './app-cookie-consent';

type PostHogProviderProps = {
  children: React.ReactNode;
  isLoggedIn: boolean;
};
export function AppPostHogProvider({
  children,
  isLoggedIn,
}: PostHogProviderProps) {
  const { isAcceptedAll } = useAppCookieConsent();
  React.useEffect(() => {
    if (isEnvDev) {
      return;
    }
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: '/api/_ingest',
      ui_host: 'https://us.posthog.com',
      person_profiles: isLoggedIn ? 'always' : 'identified_only',
      persistence: isAcceptedAll ? 'localStorage+cookie' : 'localStorage',
    });
  }, [isLoggedIn, isAcceptedAll]);
  if (isEnvDev) {
    return <>{children}</>;
  }
  return <PhProvider client={posthog}>{children}</PhProvider>;
}
